var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-container-page display-col full-height"},[_c('div',{staticClass:"search-container"},[_vm._t("search")],2),_c('div',{staticClass:"full-container flex1"},[_vm._t("full")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }